<template>
    <div class="overall-bg">
        <b-container>
            <b-row>
                <b-col>
                    <BackBtn :goback="$router.back" />
                    <Headerlayout headertext="Consumption Return"></Headerlayout>
                </b-col>
            </b-row>
        </b-container>
    </div>

    <div class="form-white-bg">
        <b-container>
            <b-row>
                <b-row>
                    <b-col lg="12">
                        <Items :showone="paramValue" :show-fields="showFields" @additemclick="AddItems" />
                    </b-col>
                </b-row>
                <b-row class="py-5">
                    <b-col>
                        <Tableview :data="items" :paginator="true" class="p-datatable-gridlines" :rows="10" :rowHover="true"
                            filterDisplay="menu" responsiveLayout="scroll" :columns="headers"
                            :globalFilterFields="globalFilterFields" :filters="filters">
                        </Tableview>
                    </b-col>
                </b-row>
                <Footer />
            </b-row>
        </b-container>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, PropType, computed } from 'vue'
import BackBtn from '../../../../components/FormComponents/BacktoMaster.vue'
import Headerlayout from '../../../../components/Masters/HeaderLayout.vue'
import Tableview from "../../../../components/FormComponents/NormalTable.vue";
import PurchaseOrder from '../../../../modules/Inventory/components/Transaction/PurchaseOrder.vue'
import Return from '../../../../modules/Inventory/components/Transaction/Return.vue'
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Items from '../../../../modules/Inventory/components/Transaction/Item.vue'
import { useRoute } from 'vue-router';
import Footer from '../../../../components/FormComponents/Footer.vue'
export default defineComponent({
    components: {
        BackBtn,
        Headerlayout,
        Tableview,
        Items,
        Footer,
        PurchaseOrder,
        Return,
    },

    setup() {
        const route = useRoute();
        let items = ref([]);

        const paramValue = computed(() => {
            return route.query.param as string;
        });
        let List = ref([])
        const headers = [
            {
                header: 'Item',
                field: 'ItemCategory1'
            },
            {
                header: 'Item Name',
                field: 'Itemname1'
            },
            {
                header: 'Batch',
                field: 'BatchNo'
            },
            {
                header: 'Pack Size',
                field: 'PackSizeId'
            },
            {
                header: 'Qty',
                field: 'ItemQuantity'
            },
            {
                header: 'Unit Rate',
                field: 'UnitRate'
            },
            {
                header: 'Discount ',
                field: 'Discount'
            },
            {
                header: 'MRP',
                field: 'MRP'
            },

        ];
        const filteredColumns = computed(() => {
            return headers.filter((col) => col.field !== "id");
        });
        const globalFilterFields = ref(headers.map((col) => col.field));
        const filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            Name: { value: null, matchMode: FilterMatchMode.IN, options: items },
            SupplierCategory: {
                value: null,
                matchMode: FilterMatchMode.IN,
                options: items,
            },
        };
        let showFields = {
            Category: true,
            Name: true,
            Batch: true,
            PackSize: true,
            UnitRate: true,
            Qty: true,
            MRP: true,
            Discount: true,
        };
        const AddItems = (value) => {
            debugger;
            console.log(value);
            items.value = value;

        };

        return {
            List,
            headers,
            paramValue,
            showFields,
            items,
            globalFilterFields,
            filters,
            filteredColumns,
            AddItems
        }
    }

})
</script>

